export const BookIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='26'
      height='22'
      viewBox='0 0 30 24'
      fill='none'
    >
      <path
        d='M24.9333 17.0635V1.46645L15.4 2.77728V18.9702L24.9333 17.0635ZM13.9333 18.9702V2.77728L4.4 1.46645V17.0635L13.9333 18.9702ZM24.7317 0.0135335C25.6162 -0.105633 26.4 0.577284 26.4 1.46645V17.0635C26.4 17.7648 25.905 18.3652 25.2221 18.5027L15.2442 20.4964C14.8637 20.5744 14.4742 20.5744 14.0937 20.4964L4.11125 18.4981C3.42375 18.3606 2.93333 17.7602 2.93333 17.0589V1.46645C2.93333 0.577284 3.71708 -0.105633 4.60167 0.0135335L14.6667 1.3977L24.7317 0.0135335ZM0 2.93312C0 2.1127 0.669167 1.46645 1.46667 1.46645V2.93312V7.26437V19.1169L14.3779 21.6973C14.5658 21.7339 14.7629 21.7339 14.9554 21.6973L27.8667 19.1169V7.26437V2.93312V1.46645C28.6642 1.46645 29.3333 2.1127 29.3333 2.93312V19.1169C29.3333 19.8181 28.8383 20.4185 28.1554 20.556L15.2442 23.1364C14.8637 23.2144 14.4742 23.2144 14.0937 23.1364L1.17792 20.5514C0.495 20.4185 0 19.8135 0 19.1169V2.93312Z'
        fill='url(#paint0_linear_16927_6236)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_16927_6236'
          x1='0.233732'
          y1='0.469532'
          x2='-8.65379'
          y2='18.1739'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FB0E00' />
          <stop offset='1' stop-color='#00219F' />
        </linearGradient>
      </defs>
    </svg>
  )
}
